import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=88c5569e&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports